const e=6048e5,o=864e5;export{o as millisecondsInDay,e as millisecondsInWeek};
//# sourceMappingURL=constants.js.map
